// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import styled from "styled-components";

import {
  ReportTypeNotice,
  ReportTypeNoticeControls,
} from "../SARDetails/ReportTypeNotice";
import { Banner } from "../shared/styles/Banner";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  height: 500px;
  align-self: stretch;
  position: relative;
  padding: 0px 20px;
`;

export interface EmptySectionProps {
  banner: string;
  presenter: ReportTypeNoticeControls;
}

export function EmptySection({ banner, presenter }: EmptySectionProps) {
  return (
    <Wrapper>
      <ReportTypeNotice presenter={presenter} />
      <Banner>{banner}</Banner>
    </Wrapper>
  );
}
